module.exports = __webpack_public_path__ + "static/img/side_qr_01.98b54b9a.jpg";